import {get} from 'lodash';

export default (state = {}, {coachId, coachAlias}: any) => {
  return {
    ...state,
    coachAlias: {
      ...get(state, 'coachAlias', {}),
      [coachId]: coachAlias,
    },
  };
};
